import { MoneylineTicketPayload } from 'services/moneyline/moneyline.types';
import { Brand, Customer, TransactionDraft } from 'services/innovorder';
import { createIntl } from 'react-intl';
import allMessages, { SupportedLanguage } from 'translation';
import { createTicketLine } from './ticketBuilder.utils';

interface Kiosk {
  kioskId: string;
  printCount: string;
}
export interface Reload {
  paymentMean: string;
  reloadAmount: number;
  transactionDate: string;
  transactionId: string;
}

export function buildTicket(
  brand: Brand,
  paymentInfos: string,
  transactionDraft: TransactionDraft,
  kiosk: Kiosk,
  customer: Customer,
  locale: SupportedLanguage,
): MoneylineTicketPayload {
  const brandLegalInfos = `SIRET ${brand.siren} NAF${brand.industryClassificationCode} TVA ${brand.taxNumber}`;
  const { address } = brand;
  const brandAddress1 = `${address.streetNumber} ${address.route}`;
  const brandAddress2 = `${address.postalCode} ${address.administrativeAreaLevel2} ${address.administrativeAreaLevel1}`;
  const customerNameAndSurame = `${customer.firstName} ${customer.lastName}`;
  const newBalance = (customer.customerBalance + transactionDraft.amount) / 100;
  const messages = allMessages[locale];

  const intl = createIntl({
    locale,
  });

  const ticket = [
    createTicketLine('feedline', 4),
    createTicketLine('line', {
      align: 'center',
      bold: true,
      size: '3',
      value: brand.name,
    }),
    createTicketLine('feedline', 2),
    createTicketLine('line', {
      value: paymentInfos,
    }),
    createTicketLine('line', {
      value: `${messages['ticket.kiosk']} : ${kiosk.kioskId}`,
    }),
    createTicketLine('feedline', 2),
    createTicketLine('line', {
      align: 'center',
      bold: true,
      size: '2',
      value: `** ${messages['ticket.title']} **`,
    }),
    createTicketLine('feedline', 1),
    createTicketLine('line', {
      value: customerNameAndSurame,
    }),
    createTicketLine('line', {
      value: customer.class,
    }),
    createTicketLine('line', {
      value: `${messages['ticket.badeNumber']} : ${customer.badgeNumber}`,
    }),
    createTicketLine('feedline', 2),
    createTicketLine('line', {
      value: `${messages['ticket.oldBalance']} :       ${intl.formatNumber(
        customer.customerBalance / 100,
        {
          style: 'currency',
          currency: 'EUR',
        },
      )}`,
      size: '3',
      bold: true,
    }),
    createTicketLine('feedline', 2),
    createTicketLine('line', {
      value: `${messages['ticket.monetiqueHelp']}`,
    }),
    createTicketLine('line', {
      align: 'right',
      value: intl.formatNumber(transactionDraft.amount / 100, {
        style: 'currency',
        currency: 'EUR',
      }),
    }),
    createTicketLine('feedline', 1),
    createTicketLine('line', {
      underline: true,
      align: 'right',
      value: `${messages['ticket.total']} :  ${intl.formatNumber(
        transactionDraft.amount / 100,
        {
          style: 'currency',
          currency: 'EUR',
        },
      )}`,
    }),
    createTicketLine('feedline', 1),
    createTicketLine('line', {
      align: 'right',
      value: `${messages['ticket.transactionId']} :  ${transactionDraft.idempotencyKey}`,
    }),
    createTicketLine('feedline', 2),
    createTicketLine('line', {
      value: `${messages['ticket.newBalance']} :       ${intl.formatNumber(
        newBalance,
        {
          style: 'currency',
          currency: 'EUR',
        },
      )}`,
      size: '3',
      bold: true,
    }),
    createTicketLine('feedline', 5),
    createTicketLine('line', {
      align: 'center',
      size: '2',
      value: brand.name,
    }),
    createTicketLine('line', {
      align: 'center',
      size: '2',
      value: `${messages['ticket.address']} ${brandAddress1}`,
    }),
    createTicketLine('line', {
      align: 'center',
      size: '2',
      value: brandAddress2,
    }),
    createTicketLine('line', {
      align: 'center',
      size: '2',
      value: brandLegalInfos,
    }),
    createTicketLine('feedline', 2),
    createTicketLine('line', {
      value: `${messages['ticket.printedAt']} : ${intl.formatDate(
        Date.now(),
      )} ${intl.formatTime(Date.now(), {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      })}`,
    }),
    createTicketLine('line', {
      value: `${messages['ticket.printId']} ${kiosk.printCount}`,
    }),
  ];
  return { Content: ticket };
}
